const notificationsRoutes = [
  {
    path: '',
    name: 'Notifications',
    component: () => import(
      /* webpackChunkName: 'notifications-page' */
      '../components/pages/Notifications.vue'
    ),
    meta: {
      title: 'Notifications',
    },
  },
];

export default notificationsRoutes;
